"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Audit/EventSheet.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _selectBlobjectByWrappedKey = require('shared/selectors/blobject/common/selectBlobjectByWrappedKey');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _format = require('web/components/Audit/format');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');









 const HOURLY_NOTE = 'Opening a chat counts once an hour per person.'; exports.HOURLY_NOTE = HOURLY_NOTE

const Row = ({ label, children }) => (
  _react2.default.createElement(_react2.default.Fragment, null
    , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 24}},  label )
    , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  children )
  )
)

/* Open chat: the chat's blobject, from the store or the server, then its
 * page. */
const useOpenChat = () => {
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [pending, setPending] = _react.useState(null)
  const blobject = _hooks.useAppSelector.call(void 0, s => pending ? _selectBlobjectByWrappedKey.selectBlobjectByWrappedKey.call(void 0, s, pending) : null)
  _react.useEffect.call(void 0, () => {
    if (!blobject) return
    setPending(null)
    _actions2.default.gotoBlobject(blobject.WrappedType, blobject.WrappedKey, blobject.Key)
  }, [blobject])
  return (key) => {
    setPending(key)
    _actions2.default.getBlobjectByWrappedKey({ WrappedKey: key }).catch(() => {
      setPending(null)
      showWarningBar('Couldn\'t open this chat.')
    })
  }
}

/* One event over the log (screen B): the patient panel's side sheet, read
 * only. Escape closes it. */
const EventSheet = ({ event, onClose, onMoreFromPerson, onMoreForPatient }) => {
  _react.useEffect.call(void 0, () => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !document.querySelector('.blm-modal')) onClose()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])
  const openChat = useOpenChat()

  const { Person: person, Patient: patient } = event
  const personSub = person.IsSupport ? 'BloomText staff' : person.Role
  return (
    _react2.default.createElement('aside', { className: "dir-drawer account-person-card audit-sheet"  , role: "dialog", 'aria-label': `${event.ActionLabel} details`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}
      , _react2.default.createElement('div', { className: "account-person-card--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}
        , _react2.default.createElement('div', { className: "account-person-card--who", __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
          , _react2.default.createElement('div', { className: "account-person-card--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}},  event.ActionLabel )
          , _react2.default.createElement('div', { className: "account-person-card--email", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  _format.formatEventTime.call(void 0, event.OccurredAt) )
        )
        , _react2.default.createElement('button', { type: "button", className: "dir-drawer--close", 'aria-label': "Close", onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
          , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-cross-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}} )
        )
      )
      , _react2.default.createElement('div', { className: "audit-sheet--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
        , _react2.default.createElement('dl', { className: "audit-sheet--fields", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
          , _react2.default.createElement(Row, { label: "Action", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, _react2.default.createElement('span', { className: `audit-chip ${_format.actionChipClass.call(void 0, event.Action)}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  event.ActionLabel ))
          , _react2.default.createElement(Row, { label: "When", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}},  _format.formatEventWhen.call(void 0, event.OccurredAt) )
          , _react2.default.createElement(Row, { label: "Organization", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}},  event.OrgName )
          , _react2.default.createElement(Row, { label: "Person", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
            ,  [person.Name, person.Email].filter(Boolean).join(' · ') 
            ,  personSub && _react2.default.createElement('span', { className: "audit-sheet--sub", __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}},  personSub ) 
          )
          ,  patient && (
            _react2.default.createElement(Row, { label: "Patient", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
              ,  [patient.Name, patient.MRN].filter(Boolean).join(' · ') 
              , _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: () => _actions2.default.gotoPatientPage(event.OrgKey, patient.PatientKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}, "Open profile" )
            )
          )
          ,  event.ConversationKey && (
            _react2.default.createElement(Row, { label: "Chat", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
              ,  event.ChatName || 'Chat' 
              /* SAFETY: a non-empty ConversationKey is the event's chat. */
              , _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: () => openChat(event.ConversationKey ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}, "Open chat" )
            )
          )
          ,  event.Details && _react2.default.createElement(Row, { label: "Details", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}},  event.Details ) 
          ,  event.Device && _react2.default.createElement(Row, { label: "Device", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}},  event.Device ) 
          ,  event.IPAddress && _react2.default.createElement(Row, { label: "IP address" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}},  event.IPAddress ) 
          , _react2.default.createElement(Row, { label: "Event ID" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}, _react2.default.createElement('span', { className: "audit-sheet--mono", __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}},  event.AuditKey ))
        )
        ,  event.Action === 'chat.viewed' && (
          _react2.default.createElement('div', { className: "audit-sheet--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
            , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-calendar-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}} )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 104}},  exports.HOURLY_NOTE )
          )
        )
        ,  (onMoreFromPerson || (onMoreForPatient && patient)) && (
          _react2.default.createElement('div', { className: "audit-sheet--more", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
            ,  onMoreFromPerson && (
              _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onMoreFromPerson, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}, "More from "
                  ,  person.IsSupport ? person.Name : _format.firstName.call(void 0, person.Name) 
              )
            )
            ,  onMoreForPatient && patient && (
              _react2.default.createElement('button', { type: "button", className: "blm-btn blm-btn--secondary" , onClick: onMoreForPatient, __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}, "More for "
                  ,  _format.firstName.call(void 0, patient.Name) 
              )
            )
          )
        )
      )
    )
  )
}

exports. default = EventSheet
